import { render } from "./AskMathewBotWindow.vue?vue&type=template&id=22ae242d&scoped=true"
import script from "./AskMathewBotWindow.vue?vue&type=script&lang=js"
export * from "./AskMathewBotWindow.vue?vue&type=script&lang=js"

import "./AskMathewBotWindow.vue?vue&type=style&index=0&id=22ae242d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ae242d"]])

export default __exports__